import type { IBookingDoctorData } from '@/entities/booking/model/types';

const defaultData: IBookingDoctorData = {
  medcenterId: 139835,
  doctorId: 1487,
  onlineBooking: {
    basedOn: 'preferred_time',
    iinRequired: false,
    timeslotsIsEmpty: true,
    schedule: null,
  },
};

export const genBookingDataDoctor = (data: Partial<IBookingDoctorData>): IBookingDoctorData[] => {
  return [
    {
      medcenterId: data.medcenterId || defaultData.medcenterId,
      doctorId: data.doctorId || defaultData.doctorId,
      onlineBooking: {
        basedOn: data.onlineBooking?.basedOn || defaultData.onlineBooking.basedOn,
        iinRequired: data.onlineBooking?.iinRequired || defaultData.onlineBooking.iinRequired,
        timeslotsIsEmpty:
          data.onlineBooking && 'timeslotsIsEmpty' in data.onlineBooking
            ? data.onlineBooking.timeslotsIsEmpty
            : defaultData.onlineBooking.timeslotsIsEmpty,
        schedule: data.onlineBooking?.schedule || defaultData.onlineBooking.schedule,
      },
    },
  ];
};
